module.exports = __webpack_public_path__ + "img/video.d2b348b1.svg";